import { useLocationService } from '@/services/location/LocationService';
import { FC } from 'react';
import { FiCalendar } from 'react-icons/fi';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { Button } from '../../../components/shared/button/Button';
import { TSTitleCard } from '../../../components/shared/card/Card';
import strings from './NextShift.translations';
import { ShiftData } from './nextShift.types';

interface NextShiftCardProps {
  shift: ShiftData;
  onViewDetails: () => void;
}

export const NextShiftCard: FC<NextShiftCardProps> = ({ shift, onViewDetails }) => {
  const location = useLocationService(state => state.selectedLocation);

  const onClick = () => {
    onViewDetails();
  };

  return (
    <TSTitleCard title={strings.nextShiftTitle} icon={FiCalendar}>
      <p className="text-lg">{strings.yourNextShift}</p>
      <div className="px-4 flex items-center w-full flex-col">
        <div className="flex flex-col items-center gap-1 my-4">
          <p className="text-2xl font-extrabold">{shift.date}</p>
          <p className="text-xl">{strings.startEndTime(shift.startTime, shift.endTime)}</p>
          <div className="border-2 border-primary-500 p-1 text-primary-500">
            <div className="flex items-center gap-1">
              <HiOutlineLocationMarker className="w-5 h-5" />
              <span className="text-sm font-semibold">{location?.name}</span>
            </div>
          </div>
        </div>
        <Button primary className="w-full" onClick={onClick}>
          {strings.viewButton}
        </Button>
      </div>
    </TSTitleCard>
  );
};
